import { ReduxState } from '@/utils/typeHelpers'

export const getAllProviders = (state: ReduxState) => state.providers

export const getProviderById = (state: ReduxState, id: number) =>
  state.providers[id]
